$(document).ready(function(){
    $('.block__migration-shopify-hero-btn').attr('href',  $('.block__migration-shopify-hero-platform:first-child').data('url'));
    $('.block__migration-shopify-hero-platform').each(function(){
        if($(this).data('title') == $('.block__migration-shopify-hero-selection-value-from').html()){
            $(this).addClass('active'); 
        }
    })
})

$('.block__migration-shopify-hero-selection-from').click(function(){
    $('.block__migration-shopify-hero-popup').show(); 
    
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    $('body').css('overflow', 'hidden');
     document.body.style.paddingRight = scrollBarWidth + 'px';
    // document.querySelector('.section-header').style.paddingRight = scrollBarWidth + 'px';
     document.querySelector('.block__migration-shopify-hero-popup').style.marginRight = scrollBarWidth + 'px';
})

$('.block__migration-shopify-hero-platform').click(function(){
    let data_src =  $(this).data('src');
    let data_url = $(this).data('cal-url');
    console.log(data_url)
    let data_title = $(this).data('title'); 
    $('.block__migration-shopify-hero-selection-image-from').attr('src', data_src);
    $('.block__migration-shopify-hero-btns').attr('data-cal-config', JSON.stringify(data_url));  
    $('.block__migration-shopify-hero-selection-value-from').html(data_title); 
    $('.block__migration-shopify-hero-platform').removeClass('active');
    $(this).addClass('active'); 
    popupClose()
});

$('.block__migration-shopify-hero-close').click(function(){
    popupClose()
});

$('.block__migration-shopify-hero-popup').click(function(){
    if($('.block__migration-shopify-hero-popup-inner:hover').length == 0){
        popupClose(); 
    }
})

// Popop close function
function popupClose(){
   $('.block__migration-shopify-hero-popup').hide(); 
   document.body.style.paddingRight = '0px';
 //  document.getElementById('shopify-section-header').style.paddingRight = '0px';
   $('body').css('overflow', 'auto');
   $('.plateForm_search_input').val('');
   $('.block__migration-shopify-hero-platform').css('display', 'block'); 
}

$('.block__migration-shopify-hero-selection-dropdown').click(function(){
    $(this).closest('.block__migration-shopify-hero-selection-dropdown-wrapper').toggleClass('active')
}); 

$('.block__migration-shopify-hero-selection-dropdown-option').click(function(){
    $(this).toggleClass('active'); 
})

$('.plateForm_search_input').keyup(function(){
     var value = $(this).val().toLowerCase();
    $('.block__migration-shopify-hero-platform').filter(function(){
         $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    })
})